<script>
import { markdown } from './util';

export let title;
export let description;
</script>

<div class="box">
  <div class="title mb-16">{title}</div>
  <div class="desc">{@html markdown(description)}</div>
  <slot />
</div>

<style lang="scss">
@import './util';
@import './theme';

.box {
  background-color: $header-box-background-color;
  color: $header-box-foreground-color;
  padding: 32px 64px;
  padding-bottom: 48px;
  margin-bottom: 32px;
  font-family: $secondary-font;

  @include mobile {
    padding: 16px;
  }
}

.title {
  font-size: 40px;
  font-weight: bold;
  font-family: $font;

  @include mobile {
    font-size: 20px;
  }
}

.desc {
  font-size: 16px;
  font-weight: 200;

  @include mobile {
    font-size: 12px;
  }
}

:global(.desc a) {
  text-decoration: underline;
}
</style>